export const EXCHANGE_RECORD_LIST = 'EXCHANGE_RECORD_LIST'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/exchange-record/store/mutations-types.js